import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useSetLocationData } from "~/hooks/locationData";
import { addGMTOffsetToDate } from "~/shared/lib/addGMTOffsetToDate";
import { Field } from "~/shared/ui/Field";

import s from "./HistoricalData.less";

const HistoricalData = ({ refetch }) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();

  const { control, watch } = useForm({ defaultValues: { date: null } });

  const chosenDate = watch("date");

  useEffect(() => {
    // Field (antd DatePicker) отдаёт dayjs — приводим к Date, как раньше
    const date = chosenDate ? dayjs(chosenDate).toDate() : null;
    if (date) {
      refetch({ ActualOn: addGMTOffsetToDate(`${date}`) });
      setData("event", addGMTOffsetToDate(`${date}`));
    } else {
      refetch({ ActualOn: new Date() });
      setData("event", null);
    }
  }, [chosenDate]);

  return (
    <div className={s.form_historical_date}>
      <span className={s.text}>{t("cep.actual_date_on")}</span>
      <Field
        type="datePicker"
        name="date"
        control={control}
        format="DD.MM.YYYY"
        disabledDate={(current) =>
          current ? current.isAfter(dayjs(), "day") : false
        }
        wrapperClassName={s.date_picker}
      />
    </div>
  );
};

export default HistoricalData;
